import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Text,
  Checkbox,
  Modal,
  ButtonGroup,
  Button,
} from '../../components';
import Features from './Features';
import withCarrierSubscription from '../withCarrierSubscription';
import api from '../../utils/services';

const propTypes = {
  carrier: PropTypes.shape({
    aqeCarrierId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  }).isRequired,
};


class AqeFeatures extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenModal: false,
      features: null,
      loading: true,
      modifiedFeatures: [],
      notifier: undefined, // required for success and error message.
    };
  }

  componentDidMount() {
    const { carrier: { aqeCarrierId } } = this.props;
    if (aqeCarrierId) {
      api.getAQEFeatures(aqeCarrierId)
        .then(({ item }) => {
          const features = item.reduce((acc, fa) => {
            acc[fa.featureId] = { name: fa.name, isEnabled: fa.isEnabled, isEdited: false };
            return acc;
          }, {});
          this.setState({ features, loading: false });
        });
    } else {
      this.setState({ loading: false });
    }
  }

  handleChange = (event) => {
    const { checked, name: featureId } = event.target;
    this.setState((prevState) => {
      const { features, modifiedFeatures } = prevState;
      const { isEdited } = features[featureId];
      features[featureId].isEnabled = checked;
      features[featureId].isEdited = !isEdited;
      // find the index of the array.
      const indexValue = modifiedFeatures.findIndex(feature => feature.featureId === featureId);

      if (indexValue === -1) {
        modifiedFeatures.push({
          featureId,
          name: features[featureId].name,
          isEnabled: features[featureId].isEnabled,
        });
      }

      // if it was edited previously, then remove it from the array.
      if (isEdited) {
        modifiedFeatures.splice(indexValue, 1);
      }

      return {
        ...prevState,
        features,
        modifiedFeatures,
      };
    });
  };

  openModal = (event) => {
    event.preventDefault();
    this.setState({ isOpenModal: true });
  };

  handleSubmit = () => {
    const { modifiedFeatures, features } = this.state;
    const { carrier: { aqeCarrierId } } = this.props;
    api.updateAQEFeatures(aqeCarrierId, modifiedFeatures)
      .then(() => {
        modifiedFeatures.forEach((modifiedFeature) => {
          features[modifiedFeature.featureId].isEdited = false;
        });
        this.setState({
          isOpenModal: false,
          modifiedFeatures: [],
          notifier: { text: 'Successfully updated the feature(s)!', colorVariant: 'green' },
        });
      })
      .catch(() => {
        modifiedFeatures.forEach((modifiedFeature) => {
          features[modifiedFeature.featureId].isEdited = false;
        });
        this.setState({ notifier: { message: 'Error updating the feature, try again!', colorVariant: 'red' } });
      });
  }


  ConfirmationModal = ({ isOpen, onClose }) => {
    const { modifiedFeatures } = this.state;
    const featureEnabled = modifiedFeatures.length > 0 ? modifiedFeatures.map((feature) => {
      const isEnabled = feature.isEnabled ? 'Enabled' : 'Disabled';
      return (
        <Text as="p" key={feature.featureId}>
          {`${feature.name} : ${isEnabled}`}
        </Text>
      );
    }) : <Text as="p">No features changed</Text>;
    return (
      <Modal title="Are you sure you want to save these feature(s)?" isOpen={isOpen} onClose={onClose}>
        <Modal.Body>
          {featureEnabled}
        </Modal.Body>
        <Modal.Footer>
          <ButtonGroup>
            <Button onClick={this.closeModal}>Cancel</Button>
            {modifiedFeatures.length > 0
             && <Button primary onClick={this.handleSubmit}>Confirm</Button>}
          </ButtonGroup>
        </Modal.Footer>
      </Modal>
    );
  };

  closeModal = () => {
    this.setState({ isOpenModal: false });
  }

  render() {
    const {
      features, loading, notifier, isOpenModal,
    } = this.state;
    const { ConfirmationModal } = this;
    const renderAqeFeatures = features ? Object.keys(features).map(featureId => (
      <Text key={featureId}>
        <Checkbox
          name={featureId}
          checked={features[featureId].isEnabled}
          label={features[featureId].name}
          onChange={this.handleChange}
        />
      </Text>
    )) : (
      <Text fontWeight="semiBold">No mappings found for ISF Carrier DB.</Text>
    );
    return (
      <React.Fragment>
        <Features
          render={renderAqeFeatures}
          title="AQE Features"
          loading={loading}
          submit={this.openModal}
          notifier={notifier}
        />
        <ConfirmationModal isOpen={isOpenModal} onClose={this.closeModal} />
      </React.Fragment>
    );
  }
}

AqeFeatures.propTypes = propTypes;
export default withCarrierSubscription(AqeFeatures);
